(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3785],{

/***/ 62822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _ListContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66987);







var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ListContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Provider */ .Z.Provider, {
    value: context
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiList'
})(List));

/***/ }),

/***/ 66987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 */

var ListContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ListContext);

/***/ }),

/***/ 50998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1591);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4024);
/* harmony import */ var _utils_isMuiElement__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83711);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17294);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66987);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);












var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {}
    }
  }, [autoFocus]);
  var children = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && (0,_utils_isMuiElement__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (instance) {
    // #StrictMode ready
    listItemRef.current = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(instance);
  }, []);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(handleOwnRef, ref);

  var componentProps = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.focusVisible, focusVisibleClassName);
    Component = _ButtonBase__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_List_ListContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Provider */ .Z.Provider, {
      value: childContext
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ContainerComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
      className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_List_ListContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Provider */ .Z.Provider, {
    value: childContext
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    ref: handleRef
  }, componentProps), children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(styles, {
  name: 'MuiListItem'
})(ListItem));

/***/ }),

/***/ 46869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66987);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    },

    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */

var ListItemIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItemIcon(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className"]);

  var context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon));

/***/ }),

/***/ 95757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1591);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22318);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66987);








var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },

  /* Styles applied to the `Typography` components if primary and secondary are set. */
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },

  /* Styles applied to the `Typography` components if dense. */
  dense: {},

  /* Styles applied to the root element if `inset={true}`. */
  inset: {
    paddingLeft: 56
  },

  /* Styles applied to the primary `Typography` component. */
  primary: {},

  /* Styles applied to the secondary `Typography` component. */
  secondary: {}
};
var ListItemText = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItemText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);

  var _React$useContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z),
      dense = _React$useContext.dense;

  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== _Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z && !disableTypography) {
    primary = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: "span",
      display: "block"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== _Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z && !disableTypography) {
    secondary = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      variant: "body2",
      className: classes.secondary,
      color: "textSecondary",
      display: "block"
    }, secondaryTypographyProps), secondary);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
    ref: ref
  }, other), primary, secondary);
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiListItemText'
})(ListItemText));

/***/ }),

/***/ 41959:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

exports.Z = _default;

/***/ }),

/***/ 92217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
}), 'ShareOutlined');

exports.Z = _default;

/***/ }),

/***/ 85984:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

exports.Z = _default;

/***/ }),

/***/ 83817:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarBorder');

exports.Z = _default;

/***/ }),

/***/ 65232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_modules_Context_useAuth0User__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65200);
/* harmony import */ var _app_modules_JobFavouriteButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76242);
/* harmony import */ var _app_utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52484);
/* harmony import */ var _cmsComponents_JobSnippet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23040);
/* harmony import */ var _components_JobApplicationStatusLabel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12042);
/* harmony import */ var _components_JobClientDetails__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52225);
/* harmony import */ var _components_JobInformation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73037);
/* harmony import */ var _components_ShareContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35079);
/* harmony import */ var _modules_JobButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91632);
/* harmony import */ var _utils_jobListingHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92628);
/* harmony import */ var _utils_useAnalytics__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9800);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41749);
/* harmony import */ var _JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(87776);
/* harmony import */ var _JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15__);


















var JobSnippetItem = function(param) {
    var data = param.data, style = param.style;
    var ref;
    var track = (0,_utils_useAnalytics__WEBPACK_IMPORTED_MODULE_11__/* .useAnalytics */ .z)();
    var id = data.id, title = data.title, isSaved = data.isSaved, appliedStatus = data.appliedStatus, grade = data.grade, jobNumber = data.jobNumber, speciality = data.speciality, subspeciality = data.subspeciality;
    var user = (0,_app_modules_Context_useAuth0User__WEBPACK_IMPORTED_MODULE_1__/* .useAuth0User */ .a)().user;
    var subspcialityOrSpeciality = subspeciality ? subspeciality : speciality;
    var jobDetailsUrl = (0,_utils_jobListingHelper__WEBPACK_IMPORTED_MODULE_10__/* .generateJobDetailsURL */ .wZ)(jobNumber, grade, subspcialityOrSpeciality);
    var jobSharingUrl = "".concat((ref = globalThis.location) === null || ref === void 0 ? void 0 : ref.origin).concat(jobDetailsUrl);
    var newLineEncoding = "%0d%0a";
    var isMultiColumnLayout = [
        _cmsComponents_JobSnippet__WEBPACK_IMPORTED_MODULE_4__.JobSnippetStyle.TwoColumns,
        _cmsComponents_JobSnippet__WEBPACK_IMPORTED_MODULE_4__.JobSnippetStyle.ThreeColumns
    ].includes(style);
    var gridSize = isMultiColumnLayout ? 12 : 6;
    var ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()((_JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15___default().container), !isMultiColumnLayout && (_JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15___default().containerBorder)),
        "data-testid": "job-snippet-item",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                container: true,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        item: true,
                        xs: style === _cmsComponents_JobSnippet__WEBPACK_IMPORTED_MODULE_4__.JobSnippetStyle.ThreeColumns ? 9 : 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            "data-testid": "job-snippet-grade",
                            className: (_JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15___default().grade),
                            children: grade
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        item: true,
                        container: true,
                        justifyContent: "flex-end",
                        xs: style === _cmsComponents_JobSnippet__WEBPACK_IMPORTED_MODULE_4__.JobSnippetStyle.ThreeColumns ? 3 : 6,
                        children: !appliedStatus && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_modules_JobFavouriteButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            id: id,
                            jobNumber: jobNumber,
                            favourited: isSaved,
                            style: null,
                            showText: style !== _cmsComponents_JobSnippet__WEBPACK_IMPORTED_MODULE_4__.JobSnippetStyle.ThreeColumns
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        sm: gridSize,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                                prefetch: false,
                                href: jobDetailsUrl,
                                as: jobDetailsUrl,
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: (_JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
                                    onClick: function() {
                                        track("Job Details", {
                                            "Details Origin": "Job Card",
                                            "Details Action": "Title Link",
                                            jobNumber: jobNumber
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        variant: "h5",
                                        component: "h2",
                                        "data-testid": "job-snippet-speciality",
                                        children: subspcialityOrSpeciality
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_JobInformation__WEBPACK_IMPORTED_MODULE_7__/* .JobInformation */ .ym, {
                                job: data
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        item: true,
                        container: true,
                        justifyContent: "space-between",
                        xs: 12,
                        sm: gridSize,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_JobClientDetails__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                user: user,
                                data: data,
                                showDetails: style !== _cmsComponents_JobSnippet__WEBPACK_IMPORTED_MODULE_4__.JobSnippetStyle.ThreeColumns
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                item: true,
                                container: true,
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                                className: (_JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15___default().bottomContainer),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ShareContainer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            jobOrArticleShare: "jobshare",
                                            id: id,
                                            className: (_JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15___default().jobShare),
                                            emailTitle: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    "Who would you like ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    " to send this job to?"
                                                ]
                                            }),
                                            emailSubject: "".concat((ref1 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref1 !== void 0 ? ref1 : "Medrecruit", " recommended a job for you"),
                                            emailBody: "View the job recommended for you by ".concat((ref2 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref2 !== void 0 ? ref2 : "Medrecruit", " ").concat(newLineEncoding).concat(encodeURI((0,_app_utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__/* .getUtmShareUrl */ .En)("jobshare", jobSharingUrl, "email"))),
                                            facebookTitle: title,
                                            shareUrl: jobSharingUrl,
                                            shareTrackingProps: {
                                                name: "Share Job",
                                                details: {
                                                    "Share Origin": "Job Card",
                                                    jobNumber: jobNumber
                                                }
                                            },
                                            popperPlacement: "bottom-start"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        item: true,
                                        className: (_JobSnippetItem_module_scss__WEBPACK_IMPORTED_MODULE_15___default().bottomButton),
                                        children: appliedStatus ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_JobApplicationStatusLabel__WEBPACK_IMPORTED_MODULE_5__/* .JobApplicationStatusLabel */ .h, {
                                            status: appliedStatus
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_JobButton__WEBPACK_IMPORTED_MODULE_9__/* .JobButton */ .E, {
                                            buttonSize: "medium",
                                            id: id,
                                            jobNumber: jobNumber,
                                            url: jobDetailsUrl,
                                            text: "See Details",
                                            trackingCallback: function() {
                                                track("Job Details", {
                                                    "Details Origin": "Job Card Snippet",
                                                    "Details Action": "Button",
                                                    jobNumber: jobNumber
                                                });
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (JobSnippetItem);


/***/ }),

/***/ 12042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ JobApplicationStatusLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25073);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var JobApplicationStatusLabel = function(param) {
    var status = param.status;
    if (status === "successful") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().status), (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[status]),
            "data-testid": "job-application-status-label",
            children: "APPLICATION ACCEPTED"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().status), (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[status]),
        "data-testid": "job-application-status-label",
        children: status.toUpperCase()
    });
};


/***/ }),

/***/ 91632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ JobButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_utils_urlHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52484);
/* harmony import */ var _modules_Context_useAuth0User__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65200);
/* harmony import */ var constants_path__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96703);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_useAnalytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9800);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(282);









var JobButton = function(param) {
    var id = param.id, jobNumber = param.jobNumber, _text = param.text, text = _text === void 0 ? "Enquire" : _text, url = param.url, trackingCallback = param.trackingCallback, _buttonSize = param.buttonSize, buttonSize = _buttonSize === void 0 ? "large" : _buttonSize, className = param.className;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var track = (0,utils_useAnalytics__WEBPACK_IMPORTED_MODULE_5__/* .useAnalytics */ .z)();
    var user = (0,_modules_Context_useAuth0User__WEBPACK_IMPORTED_MODULE_2__/* .useAuth0User */ .a)().user;
    var defaultTrackingCallback = function() {
        track("Job Enquire", {
            jobNumber: jobNumber
        });
    };
    trackingCallback = trackingCallback !== null && trackingCallback !== void 0 ? trackingCallback : defaultTrackingCallback;
    // TODO: Tidy up this function - bit all over the place
    var onClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var redirectUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                trackingCallback && trackingCallback();
                if (text === "See Details") {
                    url ? router.push(url) : router.push("/jobs/".concat(id));
                } else if (user) {
                    router.push("".concat(url).concat(constants_path__WEBPACK_IMPORTED_MODULE_3__/* .PATH.JOB_ENQUIRE */ .m.JOB_ENQUIRE));
                } else {
                    redirectUrl = (0,_app_utils_urlHelper__WEBPACK_IMPORTED_MODULE_1__/* .getRegisterUrlClientSideWithJobNumber */ .ZH)(jobNumber, "".concat(url).concat(constants_path__WEBPACK_IMPORTED_MODULE_3__/* .PATH.JOB_ENQUIRE */ .m.JOB_ENQUIRE), url);
                    router.push(redirectUrl);
                }
                return [
                    2
                ];
            });
        });
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: className,
        fullWidth: true,
        variant: "contained",
        size: buttonSize,
        color: "secondary",
        onClick: onClick,
        "data-testid": "job-button",
        children: text
    });
};


/***/ }),

/***/ 76242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ JobFavouriteButton_JobFavouriteButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./modules/Context/useAuth0User.tsx
var useAuth0User = __webpack_require__(65200);
// EXTERNAL MODULE: ./utils/clientErrorInfo.ts
var clientErrorInfo = __webpack_require__(54787);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/useGoogleAnalytics.ts


var useGoogleAnalytics = function() {
    return (0,react.useCallback)(function(eventName, eventDetails) {
        var gtag =  true ? window === null || window === void 0 ? void 0 : window.gtag : 0;
        if (!gtag) {
            return;
        }
        try {
            gtag("event", eventName, eventDetails);
        } catch (e) {
            // Just push these errors into Sentry, we can't respond to them in any useful way.
            (0,clientErrorInfo.tryToNoticeClientError)(e);
        }
    }, []);
};

// EXTERNAL MODULE: ./utils/useRequest.ts
var useRequest = __webpack_require__(87243);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(41959);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Star.js
var Star = __webpack_require__(85984);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/StarBorder.js
var StarBorder = __webpack_require__(83817);
// EXTERNAL MODULE: ./modules/JobFavouriteButton/style.module.scss
var style_module = __webpack_require__(14905);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./modules/JobFavouriteButton/JobFavouriteButton.tsx




















var JobFavouriteButton = function(param) {
    var id = param.id, jobNumber = param.jobNumber, style = param.style, _favourited = param.favourited, favourited = _favourited === void 0 ? false : _favourited, _showText = param.showText, showText = _showText === void 0 ? true : _showText, className = param.className;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var trackGA = useGoogleAnalytics();
    var router = (0,next_router.useRouter)();
    var user = (0,useAuth0User/* useAuth0User */.a)().user;
    var ref = (0,react.useState)(favourited), favourite = ref[0], setFavourite = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(true), showButtonText = ref2[0], setShowButtonText = ref2[1];
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("xs"));
    var isSaveAfterLogin = function() {
        return !!user && (router === null || router === void 0 ? void 0 : router.query.saveJobId) && id === router.query.saveJobId;
    };
    var handleSaveJobIdQueryParam = function() {
        var query = (0,_object_spread/* default */.Z)({}, router.query);
        delete query.saveJobId;
        router.push({
            pathname: router.pathname,
            query: query
        });
    };
    var getRedirectUrlForSaveJob = function() {
        return router.asPath.indexOf("?") !== -1 ? "".concat(router.asPath, "&saveJobId=").concat(id) : "".concat(router.asPath, "?saveJobId=").concat(id);
    };
    var toggleFavourite = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        trackGA("click_save_job", {});
                        if (!user) {
                            router.push((0,urlHelper/* getRegisterUrlClientSide */.SE)("save_job", getRedirectUrlForSaveJob()));
                            // there is a little blip in the UI where the favourited job is toggled before redirect. This prevents that.
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!favourite) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,useRequest/* deleteFavoriteJob */.AJ)(id)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            (0,useRequest/* addFavoriteJob */.gL)(id)
                        ];
                    case 4:
                        _state.sent();
                        track("Job Saved", {
                            jobNumber: jobNumber
                        });
                        _state.label = 5;
                    case 5:
                        setFavourite(!favourite);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        (0,clientErrorInfo.tryToNoticeClientError)(error);
                        setError(error.message);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleFavourite() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        // Only need to addFavouriteJob as you cannot unsave from a non-loggedin state
        var addFavourite = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(isSaveAfterLogin() && !favourite)) return [
                                3,
                                5
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,useRequest/* addFavoriteJob */.gL)(router.query.saveJobId)
                            ];
                        case 2:
                            _state.sent();
                            setFavourite(true);
                            handleSaveJobIdQueryParam();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            (0,clientErrorInfo.tryToNoticeClientError)(error);
                            setError(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            if (isSaveAfterLogin() && favourite) {
                                handleSaveJobIdQueryParam();
                            }
                            _state.label = 6;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function addFavourite() {
                return _ref.apply(this, arguments);
            };
        }();
        addFavourite();
    }, [
        isSaveAfterLogin,
        favourite
    ]);
    (0,react.useEffect)(function() {
        if (isMobile || !showText) {
            setShowButtonText(false);
        } else {
            setShowButtonText(true);
        }
    }, [
        isMobile,
        showText
    ]);
    var isOutlined = style === "outlined";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOutlined && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: classnames_default()((style_module_default()).button, className),
                fullWidth: true,
                variant: "outlined",
                size: "large",
                color: "secondary",
                onClick: toggleFavourite,
                "data-testid": "job-favourite-button",
                startIcon: favourite && /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {}),
                children: favourite ? "Saved" : "Save"
            }),
            !isOutlined && favourite && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {}),
                className: (style_module_default()).saveButton,
                color: "primary",
                "data-testid": "job-favourite-button",
                onClick: toggleFavourite,
                children: showButtonText ? "JOB SAVED" : null
            }),
            !isOutlined && !favourite && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarBorder/* default */.Z, {}),
                className: (style_module_default()).saveButton,
                color: "primary",
                "data-testid": "job-favourite-button",
                onClick: toggleFavourite,
                children: showButtonText ? "SAVE JOB" : null
            })
        ]
    });
};
/* harmony default export */ var JobFavouriteButton_JobFavouriteButton = (JobFavouriteButton);

;// CONCATENATED MODULE: ./modules/JobFavouriteButton/index.tsx



/***/ }),

/***/ 87776:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobSnippetItem_container__PqA4B","grade":"JobSnippetItem_grade__JI7j4","title":"JobSnippetItem_title__IcHgK","clientName":"JobSnippetItem_clientName__QYZh3","jobShare":"JobSnippetItem_jobShare__Oaqdm","bottomContainer":"JobSnippetItem_bottomContainer__sbhjy","bottomButton":"JobSnippetItem_bottomButton__sU_0_","containerBorder":"JobSnippetItem_containerBorder__V_iK_"};

/***/ }),

/***/ 25073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"status":"style_status__7Gv80","pending":"style_pending__XfIWJ","successful":"style_successful__6ks9J","unsuccessful":"style_unsuccessful__Xagi0","withdraw":"style_withdraw__0PE3e"};

/***/ }),

/***/ 14905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__rdOvl","saveButton":"style_saveButton__vB5sL","saveButtonText":"style_saveButtonText__2U5Y5"};

/***/ }),

/***/ 25892:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _wrapNativeSuper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(44998);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}


/***/ })

}]);